import React from 'react';
import styled from "styled-components";
import ConvertPixelToRem from "@helpers/convert.rem";
import RadiusGenerate from "@helpers/radius.generate";

function RadioListGroup({name, item, onChange, className}) {
    return (
        <RadioBox className={(className ? className : '')}>
            <input id={name + '_' + item.value} type="radio" onChange={onChange} name={name} checked={item.checked ? 'checked' : ''} value={item.value}/>
            <RadioLabel htmlFor={name + '_' + item.value} className="d-block cursor-pointer">{item.label}</RadioLabel>
        </RadioBox>
    )
}

export default RadioListGroup;


export const RadioLabel = styled.label`
    margin: 0;
    color: ${props => props.theme.black};
    font-size: ${ConvertPixelToRem(14)};
    border: solid 1px ${props => props.theme.gray200};
    ${RadiusGenerate('8px')};
    padding: 8px 16px ;
    background-color: ${props => props.theme.white};
    text-align: center;
    font-weight: 300;
    white-space: nowrap;
    letter-spacing: normal;
    line-height: 1.79;
`;

export const RadioBox = styled.div`

    input {
        visibility: hidden;
        display: none;
        
        &:checked + ${RadioLabel}{
            border-color: ${props => props.theme.primary};
            color: ${props => props.theme.white};
            background-color: ${props => props.theme.primary};
        }
    }
`;
